import React, { useCallback, useEffect } from 'react';
import { Support } from '../../hooks/Support';

export type SearchButtonProps = {
  enabled: boolean;
  aiProducts: string;
  code: string;
  onClick: () => void;
};

const SearchButton = ({ enabled, aiProducts, code, onClick }: SearchButtonProps) => {

  return enabled ? (
    <div className="smartplayer__search">
      <button className="smartplayer__bar-button" type="button" onClick={onClick}>
        <div className="icon icon--search">
          <svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 512 512" fill="currentColor">
            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"></path>
          </svg>
        </div>
      </button>
    </div>
  ) : null;
};

export default SearchButton;
